import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';

import { BUTTON_VARIANTS } from '@common/components/Button';
import {
  VARIANT_DEFAULT,
  VARIANT_ERROR,
  VARIANTS,
} from '@common/constants/alertBox';

import {
  AlertBoxContentWrapper,
  AlertButton,
  AlertButtonLink,
  Description,
  StyledAlertBox,
  StyledCloseButton,
  Subtitle,
  Title,
} from './AlertBox.styled';

const AlertBox = ({
  buttonText,
  className,
  description,
  onButtonClick,
  onClose,
  subtitle,
  title,
  variant,
  link,
  buttonId,
}) => (
  <StyledAlertBox
    className={className}
    variant={variant}
    data-testid="alertBox"
  >
    <AlertBoxContentWrapper variant={variant}>
      {title && (
        <Title variant="h6" withSpacing={!!onClose}>
          {title}
        </Title>
      )}
      {subtitle && (
        <Subtitle variant="paragraph1" withSpacing={!!onClose && !title}>
          {subtitle}
        </Subtitle>
      )}
      {description && (
        <Description withSpacing={!!onClose && !title && !subtitle}>
          {description}
        </Description>
      )}
      {onButtonClick && (
        <AlertButton
          onClick={onButtonClick}
          type="button"
          buttonId={buttonId}
          variant={
            variant === VARIANT_ERROR
              ? BUTTON_VARIANTS.LEVEL_2_GREY_100_15_SMALL
              : BUTTON_VARIANTS.LEVEL_2_BLUEGREY_90_SMALL_INVERTED
          }
        >
          {buttonText}
        </AlertButton>
      )}
      {link && (
        <Link {...link} passHref legacyBehavior>
          <AlertButtonLink variant={BUTTON_VARIANTS.LEVEL_2_BLUEGREY_90_SMALL}>
            {buttonText}
          </AlertButtonLink>
        </Link>
      )}
    </AlertBoxContentWrapper>
    {onClose && (
      <StyledCloseButton
        type="button"
        onClick={onClose}
        data-testid="alert-close-button"
      />
    )}
  </StyledAlertBox>
);

AlertBox.propTypes = {
  buttonText: PropTypes.string,
  buttonId: PropTypes.string,
  className: PropTypes.string,
  description: PropTypes.string,
  onButtonClick: PropTypes.func,
  onClose: PropTypes.func,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  variant: PropTypes.oneOf(VARIANTS),
  // eslint-disable-next-line react/forbid-prop-types
  link: PropTypes.shape({
    href: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
    as: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  }),
};

AlertBox.defaultProps = {
  buttonText: undefined,
  buttonId: undefined,
  className: undefined,
  description: undefined,
  onButtonClick: undefined,
  onClose: undefined,
  subtitle: undefined,
  title: undefined,
  variant: VARIANT_DEFAULT,
  link: undefined,
};

export default AlertBox;
